/**
 * @generated SignedSource<<f0353678570b1b730dba0772de7d25f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubscriptionStatusEnum = "SUBSCRIBED" | "UNSUBSCRIBED" | "%future added value";
export type SubscribeContactToListInput = {
  contactIdentifier: string;
  mailingListIdentifier: string;
};
export type AddContactToMailingListDialogMutation$variables = {
  input: SubscribeContactToListInput;
};
export type AddContactToMailingListDialogMutation$data = {
  readonly subscribeContactToList: {
    readonly id: string;
    readonly members: ReadonlyArray<{
      readonly contact: {
        readonly emailAddress?: string | null | undefined;
        readonly familyName?: string;
        readonly givenName?: string;
        readonly id: string;
        readonly teamName?: string;
      } | null | undefined;
      readonly contactIdentifier: string;
      readonly mailingListIdentifier: string;
      readonly status: SubscriptionStatusEnum;
      readonly subscribedAt: any;
      readonly unsubscribeReason: string | null | undefined;
      readonly unsubscribedAt: any | null | undefined;
    }>;
    readonly subscribedCount: number;
  };
};
export type AddContactToMailingListDialogMutation = {
  response: AddContactToMailingListDialogMutation$data;
  variables: AddContactToMailingListDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscribedCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mailingListIdentifier",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactIdentifier",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscribedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unsubscribedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unsubscribeReason",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "givenName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "familyName",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "type": "PersonContact",
  "abstractKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "type": "TeamContact",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddContactToMailingListDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MailingList",
        "kind": "LinkedField",
        "name": "subscribeContactToList",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ListMembership",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contact",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddContactToMailingListDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MailingList",
        "kind": "LinkedField",
        "name": "subscribeContactToList",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ListMembership",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "contact",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5a71f7a7adf5722db785ac8165b01f8a",
    "id": null,
    "metadata": {},
    "name": "AddContactToMailingListDialogMutation",
    "operationKind": "mutation",
    "text": "mutation AddContactToMailingListDialogMutation(\n  $input: SubscribeContactToListInput!\n) {\n  subscribeContactToList(input: $input) {\n    id\n    subscribedCount\n    members {\n      mailingListIdentifier\n      contactIdentifier\n      status\n      subscribedAt\n      unsubscribedAt\n      unsubscribeReason\n      contact {\n        __typename\n        id\n        ... on PersonContact {\n          givenName\n          familyName\n          emailAddress\n        }\n        ... on TeamContact {\n          teamName\n          emailAddress\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af377b42b6717f5b40bcb6308f4f01fe";

export default node;
